// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablaComparacionVentasDelArticuloPorCliente__SorteableHeaderTitle__JAT4_:hover {\r\n  color: rgba(0, 0, 0, 0.54);\r\n  cursor: pointer;\r\n}\r\n\r\n.TablaComparacionVentasDelArticuloPorCliente__TablasComparacionComprobantesContainer__2Ds6- {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SorteableHeaderTitle": "TablaComparacionVentasDelArticuloPorCliente__SorteableHeaderTitle__JAT4_",
	"TablasComparacionComprobantesContainer": "TablaComparacionVentasDelArticuloPorCliente__TablasComparacionComprobantesContainer__2Ds6-"
};
export default ___CSS_LOADER_EXPORT___;
